import request from 'sb-request'
import { reducers } from 'redux/core'


const { set } = reducers.misc.vindiciaUrl

const fetch = () => (
  request.post('graphql?name=vindiciaCreditCardUrl', {
    body: {
      query: `{
        config {
          vindiciaUrl: vindiciaCreditCardUrl
        }
      }`,
    },
  })
    .then(({ config }) => {
      console.log('set', config.vindiciaUrl)
      reducers.misc.vindiciaUrl.set(config.vindiciaUrl)
    })
)


export default {
  fetch,
  set,
}
